import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationCancel, NavigationEnd, Router } from '@angular/router';
import { MainMenuService, MenuNode } from '@technocom/core';
import { Subscription } from 'rxjs';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbComponent implements OnInit, OnDestroy {
  name: string;
  menu: Array<MenuNode> = [];
  breadcrumbList: Array<any> = [];
  lastUrl = '';
  subscription = new Subscription();

  lastActivatedRoute: ActivatedRoute;

  constructor(
    private _router: Router,
    private rout: ActivatedRoute,
    private menuService: MainMenuService,
    private cd: ChangeDetectorRef,
    private localize: TranslocoService,
  ) {
    this.routChanged = this.routChanged.bind(this);
  }

  ngOnInit(): void {
    this.menu = this.menuService.getMenu();
    this.listenRouting();
    // Заставляем обновляться при изменении языка
    this.subscription.add(
      this.localize.langChanges$.subscribe(() => {
        if (this.lastActivatedRoute) this._router.navigate([], { relativeTo: this.lastActivatedRoute });
      }),
    );
  }

  routChanged(router: any, routerList: Array<any>, target: any, activeUrlList: Array<MenuNode>) {
    let routerUrl = router.url;
    if (router instanceof NavigationCancel) routerUrl = this.lastUrl;
    else if (router instanceof NavigationEnd) this.lastUrl = routerUrl;
    if (routerUrl) {
      this.breadcrumbList.length = 0;
      routerList = [''].concat(routerUrl.slice(1).split('/'));
      activeUrlList = this.menu;
      routerList.forEach(linkPart => {
        target = this.menuService.getNode(linkPart !== '' ? linkPart : 'master');
        if (target) {
          if (!this.breadcrumbList.find(item => item.id === target.id)) this.breadcrumbList.push(target);
          activeUrlList = target.children;
        } else {
          let endRoot = this.rout;
          while (endRoot?.firstChild) {
            endRoot = endRoot.firstChild;
          }
          this.setText(endRoot);
          this.lastActivatedRoute = endRoot;
        }
      });
    }
    this.cd.markForCheck();
  }

  private setText(route: ActivatedRoute) {
    this.subscription.add(
      route.data.subscribe(data => {
        if (data.dataObject && !this.breadcrumbList.find(item => item.id === data.dataObject.id)) {
          this.breadcrumbList.push({
            id: data.dataObject.id,
            text:
              data.dataObject.headline ||
              data.dataObject.get('headline') ||
              data.dataObject?.getLocalizedContent().get('headline'),
          });
          this.cd.markForCheck();
        }
      }),
    );
  }

  listenRouting() {
    let routerList: Array<any>;
    let target: any;
    let activeUrlList: Array<MenuNode>;
    let lastRouter: any;
    this.subscription.add(
      this._router.events.subscribe((router: any) => {
        lastRouter = router;
        this.routChanged(router, routerList, target, activeUrlList);
      }),
    );
    this.subscription.add(
      this.menuService.onChangeEvent.subscribe(() => {
        this.routChanged(lastRouter, routerList, target, activeUrlList);
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
